export default __webpack_public_path__ + "static/media/smartphone.1a472e0f.svg";